import React, {ChangeEvent, FormEvent, useEffect, useState} from 'react'
import {
  OutageStatus,
  deleteCurrentOutage,
  getCurrentOutage,
  getCurrentOutageStatus,
  saveOutage,
  textToSpeech,
} from './TTS'
import {Toaster, toast} from 'react-hot-toast'
import Toggle from 'react-toggle'
import {useAuth} from '../../auth'

function Outage() {
  const [saving, setSaving] = useState<boolean>(false)
  const [deleting, setDeleting] = useState<boolean>(false)

  const [text, setText] = useState<string>('')

  const [audioBlob, setAudioBlob] = useState<Blob | null>()

  const [outageStatus, setOutageStatus] = useState<OutageStatus | undefined>()
  const [settingOpen, setSettingOpen] = useState<Boolean>(false)
  const {auth} = useAuth()
  useEffect(() => {
    getCurrentOutageStatus().then((res) => {
      setOutageStatus(res)
      if (res?.status === 'fault') {
        getCurrentOutage().then((res) => {
          if (res.success) {
            setAudioBlob(res.blob)
          } else {
            setAudioBlob(null)
          }
        })
      }
    })
  }, [])

  const handleSettingChange = (e) => {
    setSettingOpen(e.target.checked)
  }

  const handleTextChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value)
  }

  const handleDelete = async () => {
    try {
      setDeleting(true)
      await deleteCurrentOutage()
      setDeleting(false)
      setAudioBlob(null)
      setOutageStatus({status: 'running', text: 'Aerux Broadband is running at 100%'})
    } catch (err: any) {
      setDeleting(false)
      toast.error(err?.response?.data?.message || 'Error deleting outage audio')
    }
  }

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!text) {
      return toast.error('Please enter text')
    }

    setAudioBlob(null)

    setSaving(true)
    try {
      const response = await saveOutage(text, auth?.token)

      if (response.success) setAudioBlob(response.blob)

      setOutageStatus({
        status: response.status as 'running' | 'fault',
        text: response.text as string,
      })

      setSaving(false)
    } catch (error: any) {
      setSaving(false)
      console.error('Error:', error?.response ? error.response.data : error.message)
      return null
    }
  }
  return (
    <div className='container'>
      <Toaster />

      <form onSubmit={handleSubmit} noValidate className='form'>
        <div className='form-label'>
          <h2>Outage Alert / TTS</h2>
        </div>

        <div className='card-body border-top p-9'>
          {outageStatus?.status === 'running' ? (
            <h5 className='text-green'>
              <span>Outage disabled</span>{' '}
            </h5>
          ) : (
            <h5 className='text-red font-medium'>
              <span>Outage Active</span> : {outageStatus?.text}
            </h5>
          )}
          {audioBlob && (
            <div className='controllers d-flex flex-column mb-6 flex-md-row w-100 justify-content-between align-items-start align-items-md-center mt-2 mb-2'>
              <audio onError={(e) => console.error('Audio error:', e)} controls>
                <source src={URL.createObjectURL(audioBlob)} type='audio/wav' />
              </audio>

              <div className='div'>
                <p>
                  Audio path:{' '}
                  <a href='/public/outage.wav'>{window.location.host}/public/outage.wav</a>
                </p>

                <p>
                  Text path:{' '}
                  <a href='/public/outagestatus'>{window.location.host}/api/tts/outagestatus</a>
                </p>
              </div>
            </div>
          )}
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Text</label>

            <div className='col-lg-8'>
              <textarea
                value={text}
                onChange={handleTextChange}
                rows={5}
                className='form-control  form-control-xlg form-control-solid mb-3 mb-lg-0 w-100'
                placeholder='Enter text'
              />
            </div>
          </div>

          <div style={{maxWidth: '20rem'}} className='d-flex justify-content-between mb-6'>
            <h5 className=''>Show settings</h5>
            <Toggle checked={settingOpen} onChange={handleSettingChange} />
          </div>

          {settingOpen ? (
            <div className='settings'>
              <div className='d-flex flex-column flex-md-row  justify-content-between'>
                <div className='row col-lg-6 mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span className='required'>Language</span>
                  </label>

                  <div className='col-lg-6 fv-row'>
                    <select
                      value={'en-US'}
                      disabled
                      className='form-select form-select-solid bg-secondary form-select-lg fw-bold'
                    >
                      <option value={'en-US'}>en-US</option>
                    </select>
                  </div>
                </div>
                <div className='row col-lg-5 mb-8'>
                  <label className='col-lg-3 col-form-label fw-bold fs-6'>
                    <span className='required'>Voice</span>
                  </label>

                  <div className='col-lg-8 fv-row'>
                    <select
                      value={'en-US-News-N'}
                      disabled
                      className='form-select form-select-solid bg-secondary form-select-lg fw-bold'
                    >
                      <option value='en-US-News-N'>en-US-News-N</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span className='required'>Gender</span>
            </label>

            <div className='col-lg-8 fv-row'>
              <select
                value={gender || ''}
                onChange={handleVoiceGenderChange}
                className='form-select form-select-solid form-select-lg fw-bold'
              >
                {genders ? (
                  genders.map((gender) => <option value={gender}>{gender}</option>)
                ) : (
                  <option value={''}>Select gender...</option>
                )}
              </select>
            </div>
          </div> */}
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Pitch</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <label htmlFor='pitch'>{-3}</label>
                  <input
                    type='range'
                    id='pitch'
                    disabled
                    min={-20}
                    max={20}
                    step={0.5}
                    value={-3}
                    className='form-range form-range-solid form-range-lg fw-bold'
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Speed</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <label htmlFor='speed'>{1}</label>
                  <input
                    type='range'
                    id='speed'
                    min={0.25}
                    max={4}
                    step={0.25}
                    disabled
                    value={1}
                    className='form-range form-range-solid form-range-lg fw-bold'
                  />
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          {audioBlob && (
            <button onClick={handleDelete} className='btn btn-secondary mx-4' disabled={deleting}>
              {!deleting && 'Clear all'}
              {deleting && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          )}

          <button type='submit' className='btn btn-primary' disabled={saving}>
            {!saving && 'Activate'}
            {saving && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export default Outage
